import { ReactNode, createContext } from 'react';

interface ILayoutContext {
  /** Title in the Header */
  title: ReactNode;
  setTitle(title: ReactNode | null): void;
}

export const LayoutContext = createContext<ILayoutContext>({
  title: 'Loantrade',
  setTitle: () => {},
});
